/**
 * Extrai a data de conclusão/emissão de certificados a partir de imagens (data URL),
 * usando a API OpenAI quando `VITE_OPENAI_API_KEY` está definida.
 * PDF não é enviado (o modelo de chat com imagem exige imagem).
 */

const YMD_RE = /(\d{4})-(\d{2})-(\d{2})/;

export async function extractDataConclusaoCertificadoIa(
  dataUrl: string,
  mimeType: string
): Promise<string | null> {
  const key = import.meta.env.VITE_OPENAI_API_KEY?.trim();
  if (!key) return null;
  if (!mimeType.startsWith('image/')) return null;

  const body = {
    model: 'gpt-4o-mini',
    messages: [
      {
        role: 'system' as const,
        content:
          'Extrai apenas a data de conclusão, realização ou emissão do certificado visível no documento. Responde exclusivamente com uma data no formato ISO YYYY-MM-DD. Se não houver data legível com confiança, responde NONE.',
      },
      {
        role: 'user' as const,
        content: [
          {
            type: 'text' as const,
            text: 'Qual é a data de conclusão ou emissão deste certificado? Responde só com YYYY-MM-DD ou NONE.',
          },
          { type: 'image_url' as const, image_url: { url: dataUrl } },
        ],
      },
    ],
    max_tokens: 40,
    temperature: 0,
  };

  try {
    const res = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${key}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) return null;
    const json = (await res.json()) as {
      choices?: { message?: { content?: string } }[];
    };
    const text = json.choices?.[0]?.message?.content?.trim() ?? '';
    if (!text || /^NONE$/i.test(text)) return null;
    const m = text.match(YMD_RE);
    if (!m) return null;
    return m[0];
  } catch {
    return null;
  }
}
